export default __webpack_public_path__ + "static/mid5a-5dff7de42d77d80fe3d45209e51d5942.png";